import React, { useState, useEffect } from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import { ReactComponent as Arrow } from './arrow.svg';
import style from './block.module.scss';
import clsx from 'clsx';

const Block = () => {
    const [isVisible, setIsVisible] = useState(false);

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <BlockWrapper.Div>
            <Arrow className={clsx(style.block, isVisible && style.visible)} onClick={scrollTop} />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    setup: {
        title: 'Flèche de scroll',
    },
});
